import React, { useEffect, useState } from "react";

function RechargeSuccess() {
  return (
    <div class="content-wrapper">
      <div class="row">
        <div class="col-lg-12 grid-margin stretch-card">
          <div class="card">
            <div class="card-body">
              <div class="rechargeSuccess">
                <div class="checkmark">✔️</div>
                <h1>Recharge Successful</h1>
                <p>Thank you! Your recharge was completed successfully.</p>
                <div class="details">
                  <p><strong>Transaction ID:</strong> TXN1234567890</p>
                  <p><strong>Mobile Number:</strong> +1 234-567-8901</p>
                  <p><strong>Amount:</strong> $10.00</p>
                  <p><strong>Date & Time:</strong> May 30, 2025 – 2:45 PM</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RechargeSuccess;
